import { render, staticRenderFns } from "./EmergencyTransportPatientDetail.vue?vue&type=template&id=fcffbfa4&scoped=true&lang=pug"
import script from "./EmergencyTransportPatientDetail.vue?vue&type=script&lang=ts"
export * from "./EmergencyTransportPatientDetail.vue?vue&type=script&lang=ts"
import style0 from "./EmergencyTransportPatientDetail.vue?vue&type=style&index=0&id=fcffbfa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcffbfa4",
  null
  
)

export default component.exports